import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVerticalAlignmentCenter: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vertical-alignment-center"><path d="M12 3.75V6.75M12 17.25V20.25M12 10.25V13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 6.75H4.75V10.25H19.25V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.25 13.75H6.75V17.25H17.25V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVerticalAlignmentCenter;
